/** Legacy path `/app/oauth-native-callback` — same screen as `/oauth-native-callback` (deep links + old Supabase URLs). */
export { default } from '../oauth-native-callback'
